<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Tell us about your business</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-warning2 text-justify" v-if="formLoan.bt_code">
                            <span v-if="formLoan.bt_code=='BT2020004'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Applicant must be the officer duly authorized by the business to obtain a loan from Small Business Corporation</span>
                            <span v-if="formLoan.bt_code=='BT2020002'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Applicant must be the officer duly authorized by the business to obtain a loan from Small Business Corporation</span>
                            <span v-if="formLoan.bt_code=='BT2020001'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Must be the sole proprietor/business owner</span>
                            <span v-if="formLoan.bt_code=='BT2020003'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Applicant must be the officer duly authorized by the business to obtain a loan from Small Business Corporation</span>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Type of Business</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.bt_code" @change="selectedBusType" :class="{'is-invalid': submitting && $v.formLoan.bt_code.$error}">
                                        <option selected disabled :value='null'>- Select -</option>
                                        <option value="BT2020001">Sole Proprietorship</option>
                                        <option value="BT2020002">Partnership</option>
                                        <option value="BT2020004">Corporation</option>
                                        <option value="BT2020003">Cooperative</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div v-if="formLoan.bt_code">
                            <hr>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Please select below (1) the business name if you are applying for an additional loan for the same business, (2) a new application for a different business or (3) you don't have a previous loan application with SB Corp.</label>
                                        <select class="form-control custom-select-sm" v-model="formLoan.loan_cat" @change="selectLoanCat(formLoan.loan_cat)" :class="{'is-invalid': submitting && $v.formLoan.loan_cat.$error}">
                                            <option selected disabled :value='null'>- Select -</option>
                                            <option v-for="i in bus_options" :value="i.id" :key="i.id">{{i.text}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group" v-if="business_info.length">
                                        <label>Select Business</label>
                                        <v-select label="business_name" class="text-uppercase" :options="business_info" :reduce="business_name => business_name.id" v-model="formLoan.bus_id" :clearable="false" @input="getBusID(formLoan.bus_id)" :class="{'vs-invalid': submitting && $v.formLoan.bus_id.$error}"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div v-if="formLoan.loan_cat > 1 || formLoan.bus_id">
                                <div>
                                    <hr>
                                    <p class="card-text text-justify bold">Business Details</p>
                                    <div class="alert alert-info2">
                                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>Please make sure that the business name you indicate matches the business name indicated in your business permit.
                                    </div>

                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class="form-group">
                                                <label v-if="formLoan.bt_code=='BT2020002'">Partnership Name</label>
                                                <label v-if="formLoan.bt_code=='BT2020004'">Corporation Name</label>
                                                <label v-if="formLoan.bt_code=='BT2020001'">Business Name</label>
                                                <input type="text" :disabled="da_busname" class="form-control form-control-sm text-uppercase" @input="formLoan.business_name=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.business_name" :class="{'is-invalid': submitting && $v.formLoan.business_name.$error}" />
                                            </div>
                                        </div>
                                        <div class="col-md-3" v-if="isFirstTimer">
                                            <div class="form-group">
                                                <label>Business Start Date</label>
                                                <date-range-picker @input="validatingDate(formLoan.start_date)" ref="start_date" v-if="start_date" class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.formLoan.start_date.$error}" id="start_date" v-model="formLoan.start_date" :max-date="maxStartDate" :min-date="minStartDate" :start-date="startingDate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxStartDate" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                                                <div v-show="submitting && $v.formLoan.start_date.$error" class="danger fs-13">Required at least 2 years</div>
                                                <div v-show="submitting && validDate==false" class="danger fs-13">Invalid date format</div>
                                            </div>
                                        </div>
                                        <div class="col-md-3" v-else>
                                            <div class="form-group">
                                                <label>Startup Date</label>
                                                <date-range-picker @input="validatingDate(formLoan.start_date)" ref="start_date" v-if="start_date" class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.formLoan.start_date.$error}" id="start_date" v-model="formLoan.start_date" :max-date="maxStartDate1" :min-date="minStartDate" :start-date="startingDate1" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxStartDate1" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                                                <div v-show="submitting && $v.formLoan.start_date.$error" class="danger fs-13">Required at least 1 years</div>
                                                <div v-show="submitting && validDate==false" class="danger fs-13">Invalid date format</div>
                                            </div>
                                        </div>


                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Years of operation</label>
                                                <input type="text" disabled class="form-control form-control-sm" :value="totalYears">
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- Business Address -->
                                <div>
                                    <hr>
                                    <p class="card-text bold fs-17">Business Address</p>

                                    <p class="card-text text-justify">Is this similar to home address?<b class="danger fs-17">*</b>&nbsp;&nbsp;<a href="javascript:void(0)" data-toggle="modal" data-target="#modalHomeAdd">View Home Address</a></p>
                                    <div class="row">
                                        <div class="col-6 text-center">
                                            <div class="icheck-primary d-inline">
                                                <input type="radio" id="y1" value="Y" v-model="similarAddress" @input="sameAddress('Y')">
                                                <label for="y1" :class="{ 'errorRadio': submitting && $v.similarAddress.$error }">Yes</label>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="icheck-primary d-inline">
                                                <input type="radio" id="n1" value="N" v-model="similarAddress" @input="sameAddress('N')">
                                                <label for="n1" :class="{ 'errorRadio': submitting && $v.similarAddress.$error }">No (If no, kindly provide the details)</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="similarAddress">
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Province<b class="danger fs-17">*</b></label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="province" :class="{'vs-invalid': submitting && $v.formLoan.province_code.$error }" :options="provinces" :reduce="province => province.province_code" v-model="formLoan.province_code" :clearable="false" @input="getCity(formLoan.province_code), formLoan.city_code='',  formLoan.bcode='', brgys=[]"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>City/Municipality<b class="danger fs-17">*</b></label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="city" :class="{'vs-invalid': submitting && $v.formLoan.city_code.$error }" :options="cities" :reduce="city => city.city_code" v-model="formLoan.city_code" :clearable="false" @input="getBrgy(formLoan.city_code), formLoan.bcode=''"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Barangay<b class="danger fs-17">*</b></label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="bname" :class="{'vs-invalid': submitting && $v.formLoan.bcode.$error }" :options="brgys" :reduce="bname => bname.bcode" v-model="formLoan.bcode" :clearable="false"></v-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>House No/Block & Lot/Building<b class="danger fs-17">*</b></label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" @input="formLoan.bldg=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.bldg" :class="{'is-invalid': submitting && $v.formLoan.bldg.$error}">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Street Name / Subdivision<b class="danger fs-17">*</b></label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" @input="formLoan.street_address=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.street_address" :class="{'is-invalid': submitting && $v.formLoan.street_address.$error}">
                                                </div>
                                            </div>
                                        </div>


                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Business Address Ownership<b class="danger fs-17">*</b></label>
                                                    <v-select placeholder="- Select -" v-model="formLoan.add_ship" :class="{'vs-invalid': submitting && $v.formLoan.add_ship.$error }" append-to-body :calculate-position="withPopper" label="owner_desc" :options="ownership" :reduce="owner_desc => owner_desc.owner_code" :clearable="false"></v-select>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Number of Branches<b class="danger fs-17" v-if="formLoan.bt_code!='BT2020001'">*</b></label>
                                                    <input type="number" class="form-control form-control-sm text-uppercase" v-model.trim="formLoan.num_branches" :class="{'is-invalid': submitting && $v.formLoan.num_branches.$error}">
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Business Industry<b class="danger fs-17">*</b></label>
                                                    <v-select placeholder="- Select -" v-model="formLoan.industry" :class="{'vs-invalid': submitting && $v.formLoan.industry.$error }" append-to-body :calculate-position="withPopper" label="industry_desc" :options="industry" :reduce="industry_desc => industry_desc.industry_code" :clearable="false"></v-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Website/Social Media (Business)</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.social_media" maxlength="300">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Business Activity</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.buss_activity" maxlength="100">
                                                </div>
                                            </div>
                                        </div>


                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>TIN Number</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.tin">
                                                </div>
                                            </div>
                                            <div class="col-md-4" v-if="formLoan.bt_code=='BT2020001'">
                                                <div class="form-group">
                                                    <label>PhilSys</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.philsys">
                                                </div>
                                            </div>
                                            <div class="col-md-4" v-if="formLoan.bt_code!='BT2020001'">
                                                <div class="form-group">
                                                    <label>Number of subsidiaries</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.num_subsidiary">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
                <ModalHomeAddress :id="'modalHomeAdd'" :formAddress="formAddress" />
            </div>

        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import ModalHomeAddress from '@vues/ModalHomeAddress.vue';

    // api
    import {
        apiRefBusinessRegistry,
        apiGetBusInfo,
        apiGetCertainBusInfo,
        apiRefCity,
        apiRefBrgy,
        apiGetHomeAddress,
        apiCheckBusinessFT,
        apiDiscontinueRiseUp,
        apiCheckPendingApp,
        apiUpdateBusinessLoanReq
    } from "@js/api/applyLoanApi";

    import {
        createPopper
    } from '@popperjs/core';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        components: {
            ModalHomeAddress,
        },
        props: ['formLoan', 'user'],
        data() {
            return {

                bus_options: [{
                    id: 1,
                    text: 'Existing Business'
                }, {
                    id: 2,
                    text: 'Additional Application for new business'
                }, {
                    id: 3,
                    text: 'No previous loan application'
                }, ],


                formAddress: {},
                similarAddress: '',
                ownership: [],
                industry: [],

                provinces: [],
                regions: [],
                cities: [],
                brgys: [],
                business_info: [],
                nature_bus: [],
                submitting: false,

                today: moment().format('MM/DD/YYYY'),
                minStartDate: moment('01/01/1900', 'MM/DD/YYYY').format('MM/DD/YYYY'),
                maxStartDate: moment().subtract(2, 'years').format('MM/DD/YYYY'),
                start_date: false,
                startingDate: moment().subtract(2, 'years').format('MM/DD/YYYY'),
                validDate: undefined,
                bus_region: null,

                startingDate1: moment().subtract(1, 'years').format('MM/DD/YYYY'),
                maxStartDate1: moment().subtract(1, 'years').format('MM/DD/YYYY'),
            }
        },

        validations: {
            similarAddress: {
                required
            },
            formLoan: {
                bt_code: {
                    required
                },
                loan_cat: {
                    required
                },
                bus_id: {
                    required
                },
                business_name: {
                    required
                },
                start_date: {
                    required
                },
                province_code: {
                    required
                },
                city_code: {
                    required
                },
                bcode: {
                    required
                },
                bldg: {
                    required
                },
                street_address: {
                    required
                },

                add_ship: {
                    required
                },
                num_branches: {
                    required: requiredIf(function() {
                        return this.formLoan.bt_code != 'BT2020001'
                    })
                },
                industry: {
                    required
                },
            },
        },
        created() {
            this.initData();
        },
        methods: {
            loadCertainBusInfo(data) {
                this.formLoan.business_name = data.business_name;
                this.formLoan.total_years = data.total_years;
                this.formLoan.start_date = data.start_date;
                this.formLoan.nbuss_code = data.nbuss_code;

                if (this.similarAddress != 'Y') {
                    this.formLoan.bcode = data.bcode;
                    this.formLoan.city_code = data.city_code;
                    this.formLoan.province_code = data.province_code;
                    this.formLoan.bname = data.bname;
                    this.formLoan.city = data.city;
                    this.formLoan.province = data.province;
                    this.formLoan.bldg = data.bldg;
                    this.formLoan.street_address = data.street_address;
                }

                if (this.formLoan.start_date) {
                    this.formLoan.s_start_date = moment(this.formLoan.start_date, "MM/DD/YYYY").format("YYYY-MM-DD");
                    this.formLoan.start_date = moment(this.formLoan.start_date, "YYYY-MM-DD").format("MM/DD/YYYY");
                    this.start_date = true;
                    let min_year = moment().diff(this.formLoan.start_date, 'years');
                    if (min_year < 2) {
                        this.formLoan.start_date = null;
                        document.getElementById("start_date").value = "";
                    } else {
                        document.getElementById("start_date").value = this.formLoan.start_date;
                    }
                    this.startingDate = this.formLoan.start_date;
                }
                if (!this.formLoan.start_date) {
                    this.startingDate = this.maxStartDate;
                    this.start_date = true;
                }
            },
            async getCertainBusInfo(id) {
                try {
                    this.$emit('load', 1);
                    const data = await apiGetCertainBusInfo(id);
                    if (data && Object.keys(data).length > 0) {
                        this.loadCertainBusInfo(data);
                        if (this.similarAddress != 'Y') {
                            this.getCity(data.province_code);
                            this.getBrgy(data.city_code);
                        }
                    }
                } catch (error) {
                    this.$emit('error', error);

                } finally {
                    this.$emit('load', -1);
                }
            },
            async getCity(val) {
                if (val) {
                    try {
                        this.$emit('load', 1);
                        this.cities = await apiRefCity(val);
                    } catch (error) {
                        this.$emit('error', error);

                    } finally {
                        this.$emit('load', -1);
                    }
                }
            },
            async getBrgy(val) {
                if (val) {
                    try {
                        this.$emit('load', 1);
                        this.brgys = await apiRefBrgy(val);
                    } catch (error) {
                        this.$emit('error', error);
                    } finally {
                        this.$emit('load', -1);
                    }
                }
            },
            getBusID(id) {
                this.start_date = false;
                if (this.business_info.length > 0) {
                    this.getCertainBusInfo(id)
                    this.startingDate = this.maxStartDate;
                    this.start_date = true;
                } else {
                    this.formLoan.business_name = null;
                    this.formLoan.total_years = null;
                    this.formLoan.start_date = null;
                    this.formLoan.s_start_date = null;
                    this.formLoan.bcode = null;
                    this.formLoan.city_code = null;
                    this.formLoan.province_code = null;
                    this.formLoan.bcode = null;
                    this.formLoan.bldg = null;
                    this.formLoan.street_address = null;
                    this.start_date = true;
                    this.startingDate = this.maxStartDate;
                    document.getElementById("start_date").value = "";
                }
            },
            async getBusInfo() {
                if (this.formLoan.bt_code) {
                    this.business_info = [];
                    try {
                        this.$emit('load', 1);
                        const data = await apiGetBusInfo(this.formLoan.borrower_id, this.formLoan.bt_code);
                        if (data.length > 0) {
                            this.business_info = data;
                            this.formLoan.loan_cat = 1;
                            this.start_date = true;
                            this.getBusID(this.formLoan.bus_id);
                        } else {
                            this.formLoan.bus_id = '';
                            this.formLoan.province_code = '';
                            this.formLoan.city_code = '';
                            this.formLoan.bcode = '';
                            this.formLoan.bldg = '';
                            this.formLoan.street_address = '';
                            this.formLoan.start_date = '';
                            this.formLoan.business_name = '';
                            this.formLoan.nbuss_code = '';
                            this.startingDate = this.maxStartDate;
                            this.start_date = true;
                            this.formLoan.loan_cat = 3;
                            this.formLoan.bus_id = 0;
                        }
                    } catch (error) {
                        this.$emit('error', error);

                    } finally {
                        this.$emit('load', -1);
                    }
                }
            },
            async initData() {
                this.$emit('load', 1);
                try {
                    // Initiate both API requests concurrently
                    const queRegistry = apiRefBusinessRegistry();
                    const queAddress = apiGetHomeAddress(this.formLoan.borrower_id);

                    // Wait for both promises to resolve
                    const [registry, address] = await Promise.all([queRegistry, queAddress]);
                    const {
                        industry,
                        ownership,
                        provinces,
                        regions
                    } = registry;

                    this.industry = industry;
                    this.ownership = ownership;
                    this.provinces = provinces;
                    this.regions = regions;

                    this.formAddress = address;
                    this.getBusInfo();
                } catch (error) {
                    this.$emit('error', error);

                } finally {
                    this.$emit('load', -1);
                }
            },
            sameAddress(val) {
                if (val == 'Y') {
                    this.formLoan.province_code = this.formAddress.province_code
                    this.formLoan.city_code = this.formAddress.city_code
                    this.formLoan.bcode = this.formAddress.bcode
                    this.formLoan.bldg = this.formAddress.bldg
                    this.formLoan.street_address = this.formAddress.street_address
                    this.formLoan.add_ship = this.formAddress.add_ship

                    this.getCity(this.formAddress.province_code);
                    this.getBrgy(this.formAddress.city_code);
                } else {
                    this.formLoan.province_code = ''
                    this.formLoan.city_code = ''
                    this.formLoan.bcode = ''
                    this.formLoan.bldg = ''
                    this.formLoan.street_address = ''
                    this.formLoan.add_ship = ''
                    this.brgys = [];
                    this.cities = [];
                }
            },

            async discontinueApp() {
                try {
                    this.$emit('load', 1);
                    const res = await apiDiscontinueRiseUp(this.formLoan.application_id);
                    this.$router.push('/apply-loan');
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },


            async updateBusinessLoanReq() {
                const form = {
                    borrower_id: this.formLoan.borrower_id,
                    bt_code: this.formLoan.bt_code,
                    business_name: this.formLoan.business_name,
                    total_years: this.formLoan.total_years,
                    start_date: this.formLoan.s_start_date,
                    bcode: this.formLoan.bcode,
                    bldg: this.formLoan.bldg,
                    street_address: this.formLoan.street_address,
                    application_id: this.formLoan.application_id,
                    bus_id: this.formLoan.bus_id,
                    areacode: this.formLoan.areacode,
                    nbuss_code: this.formLoan.nbuss_code,
                    loan_bus_code: this.formLoan.loan_bus_code,

                    num_subsidiary: this.formLoan.num_subsidiary,
                    buss_activity: this.formLoan.buss_activity,
                    social_media: this.formLoan.social_media,
                    industry: this.formLoan.industry,
                    add_ship: this.formLoan.add_ship,
                    num_branches: this.formLoan.num_branches,
                    tin: this.formLoan.tin,
                    philsys: this.formLoan.philsys,
                }

                try {
                    this.$emit('load', 1);
                    const {
                        bus_id
                    } = await apiUpdateBusinessLoanReq(form);
                    this.formLoan.bus_id = bus_id;
                    this.$emit('next');
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },

            async checkPendingApp() {
                const form = {
                    borrower_id: this.formLoan.borrower_id,
                    application_id: this.formLoan.application_id,
                    bus_id: this.formLoan.bus_id,
                    business_name: this.formLoan.business_name,
                    bt_code: this.formLoan.bt_code
                }

                try {
                    this.$emit('load', 1);
                    const {
                        msg,
                        status
                    } = await apiCheckPendingApp(form);

                    if (status == 1) {
                        this.updateBusinessLoanReq();
                    } else {
                        Swal.fire({
                            icon: 'info',
                            text: `${msg}`,
                            title: 'Notice',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.value) {
                                return status == 2 ? false : this.$router.push('/dashboard');
                            }
                        })
                    }
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },

            async submitFT() {
                const name = this.name_borrower;
                const business = this.formLoan.business_name;
                try {
                    this.$emit('load', 1);
                    const {
                        existing
                    } = await apiCheckBusinessFT(name, business);

                    if (existing == 1) {
                        Swal.fire({
                            icon: 'info',
                            html: '<p class="fs-18 mx-n2 text-justify">This lending program is for new SB Corporation loan applicants only.</p>',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonText: 'Ok',
                        }).then((response) => {
                            this.discontinueApp();
                        })

                    } else {
                        this.checkPendingApp();
                    }

                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },


            next: _.debounce(function() {
                this.submitting = false;
                this.submitting = true;
                this.$v.formLoan.$touch();
                this.$v.similarAddress.$touch();
                this.formLoan.areacode = this.filterAreaCode;
                this.bus_region = this.filterRegion;

                if (this.$v.formLoan.$invalid || this.$v.similarAddress.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            },
                            validation: 1,
                        }
                    };
                    this.$emit('error', err);
                } else {

                    this.formLoan.s_start_date = moment(this.formLoan.start_date, "MM/DD/YYYY").format("YYYY-MM-DD");
                    let start_date = this.formLoan.s_start_date;
                    let years = moment().diff(start_date, 'years');
                    let months = moment().diff(start_date, 'months');
                    let countMonths = months % 12;
                    this.formLoan.total_years = years + '.' + countMonths;

                    switch (this.formLoan.loan_bus_code) {
                        case 'FIB11':
                        case 'FIB22':
                        case 'FIB29':
                            this.submitFT();
                            break;
                        case 'FIB10':
                        case 'FIB21':
                        case 'FIB28':
                            this.checkPendingApp();
                            break;
                        default:
                            break;
                    }
                }
            }, 333),
            validatingDate(e) {
                this.validDate = this.isDate(e)
            },
            isDate(val) {
                return moment(val, 'MM/DD/YYYY', true).isValid();
            },

            selectLoanCat(val) {
                this.start_date = false;
                if (val == 2 || val == 3) {
                    this.formLoan.bus_id = 0;
                    this.formLoan.province_code = '';
                    this.formLoan.city_code = '';
                    this.formLoan.bcode = '';
                    this.formLoan.bldg = '';
                    this.formLoan.street_address = '';
                    this.formLoan.start_date = '';
                    this.formLoan.business_name = '';
                    this.startingDate = this.maxStartDate;
                    this.start_date = true;

                    this.cities = [];
                    this.brgys = [];
                    this.business_info = [];
                    var x = document.getElementById("start_date");
                    if (x) {
                        x.value = '';
                    }
                } else {
                    this.getBusInfo();
                }
            },
            selectedBusType() {
                this.formLoan.loan_cat = null;
                this.formLoan.bus_id = null;
                this.getBusInfo();
            },

            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {

                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;


                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: 'top',
                    modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }
                    ]
                });
                return () => popper.destroy();
            },
        },
        computed: {
            isFirstTimer() {
                const ft = ['FIB11', 'FIB16', 'FIB22', 'FIB29'];
                return ft.includes(this.formLoan.loan_bus_code);
            },
            totalYears() {
                let yy = '-';
                if (this.formLoan.start_date) {
                    const startDate = moment(this.formLoan.start_date, 'MM/DD/YYYY');
                    const endDate = moment();
                    const duration = moment.duration(endDate.diff(startDate));
                    const years = duration.years();
                    const months = duration.months();
                    yy = years + (months / 12);
                    yy = yy.toFixed(2);
                }
                return yy;
            },
            filterNatureBus() {
                let x = this.formLoan.loan_bus_code;
                let arr = this.nature_bus;
                if (arr) {
                    arr = arr.filter(function(item) {
                        return item.cares == 'T';
                    });
                }
                return arr;
            },
            filterAreaCode() {
                let region = null;
                let prov_region_code = null;
                let area_code = null;
                if (this.formLoan.province_code && this.provinces.length != 0 && this.regions.length != 0) {
                    prov_region_code = this.provinces.find(item => item.province_code === this.formLoan.province_code).region_code;
                    area_code = this.regions.find(item => item.region_code === prov_region_code).area_code;
                }
                return area_code;
            },
            filterRegion() {
                let region = null;
                let prov_region_code = null;
                let area_code = null;
                if (this.formLoan.province_code && this.provinces.length != 0 && this.regions.length != 0) {
                    prov_region_code = this.provinces.find(item => item.province_code === this.formLoan.province_code).region_code;
                }
                return prov_region_code;
            },
            da_busname() {
                if (this.formLoan.bus_id > 0) {
                    return true;
                }
                return false;
            },
            name_borrower() {
                if (!this.user) {
                    return ''; // Return an empty string if user is not defined
                }
                const {
                    fname,
                    mname,
                    lname,
                    suffix_desc
                } = this.user;
                let nameParts = [fname, mname, lname, suffix_desc].filter(part => part); // Filter out undefined or null parts
                return nameParts.join(' ').trim();
            }

        },
        mounted() {}
    }
</script>